<template>
  <div class="hello">

    <b-container>
        <b-row>
            <b-col>
                <h4>Sign Up</h4>
            </b-col>
        </b-row>
    </b-container>

    <section class="section">
    <div class="container">
        <div class="columns">
            <div class="column is-8 is-offset-2">
                <horizontal-stepper :steps="signUpSteps" @completed-step="completeStep"
                                    @active-step="isStepActive" @stepper-finished="alert"
                >                     
                </horizontal-stepper>
            </div>
        </div>
    </div>
</section>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import HorizontalStepper from 'vue-stepper';
import Signup1 from './Signup1.vue';
import Signup2 from './Signup2.vue';
import Signup3 from './Signup3.vue';
import Signup4 from './Signup4.vue';

export default {    

    props: [],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'newUserIsBrewer'])
    },

    components: {
        HorizontalStepper,
    },

    data() {
        return {
            signUpSteps: [
                    {
                        icon: 'person',
                        name: 'accounttype',
                        subtitle: 'Buyer or Seller',
                        component: Signup1,
                        completed: false
 
                    },
                    {
                        icon: 'report_problem',
                        name: 'terms',
                        subtitle: 'Terms and Conditions',
                        component: Signup2,
                        completed: false
                    },
                    {
                        icon: 'map',
                        name: 'contactinfo',
                        subtitle: 'Contact',
                        component: Signup3,
                        completed: false
                    },
                    {
                        icon: 'report_problem',
                        name: 'emailpassword',
                        subtitle: 'Account Setup',
                        component: Signup4,
                        completed: false
                    }
            ],
            isBrewer:-10,

        }
    },

    methods:{
        completeStep(payload) {
                this.signUpSteps.forEach((step) => {
                    if (step.name === payload.name) {
                        step.completed = true;
                        console.log("Completed step: " + step.name)
                        console.log("newUserIsBrewer: " + this.newUserIsBrewer)

                    }
                })
            },
            // Executed when @active-step event is triggered
            isStepActive(payload) {
                this.signUpSteps.forEach((step) => {
                    if (step.name === payload.name) {
                        if(step.completed === true) {
                            step.completed = false;
                        }
                    }
                })
            },
            // Executed when @stepper-finished event is triggered
            alert(payload) {
                alert('end')
            },

    },

    mounted(){
    },
}
</script>

